import { ReactElement, useCallback, useEffect, useState } from 'react';

import { TimetableEvent } from '@dreryk/react-calendar';

import { AppointmentEventSlotData } from '../../AppointmentsTimetable.types';

import {
   AppointmentsTimetableEventSelectionEventDetail,
   registerAppointmentsTimetableEventSelectionEventListener,
} from './AppointmentsTimetableEventSelection.events';

type AppointmentsTimetableEventSelectionRenderProps = {
   selectedEvent: TimetableEvent<AppointmentEventSlotData>;
   selectedEventElement: HTMLDivElement | null;
   unselectEvent: VoidFunction;
};

type AppointmentsTimetableEventSelectionProps = {
   readonly onUnselect: VoidFunction;
   readonly children: (renderProps: AppointmentsTimetableEventSelectionRenderProps) => ReactElement | null;
};

export const AppointmentsTimetableEventSelection = (
   props: AppointmentsTimetableEventSelectionProps
): ReactElement | null => {
   const [detail, setDetail] = useState<AppointmentsTimetableEventSelectionEventDetail>();

   useEffect(() => registerAppointmentsTimetableEventSelectionEventListener((event) => setDetail(event.detail)), [
      setDetail,
   ]);

   const unselectEvent = useCallback(() => {
      setDetail(undefined);
      props.onUnselect();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onUnselect]);

   if (!detail) {
      return null;
   }

   return props.children({
      selectedEvent: detail.event,
      selectedEventElement: detail.eventElement,
      unselectEvent: unselectEvent,
   });
};
